import { render, staticRenderFns } from "./recipeItem.vue?vue&type=template&id=278d67b3&scoped=true"
import script from "./recipeItem.vue?vue&type=script&lang=js"
export * from "./recipeItem.vue?vue&type=script&lang=js"
import style0 from "./recipeItem.vue?vue&type=style&index=0&id=278d67b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278d67b3",
  null
  
)

export default component.exports